import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "PurchaseOrderIdsInput",
    "ShippingOptions",
    "SelectedShippingOption",
    "ShippingOptionValidationMessage",
    "SupplierNameInput",
    "SupplierStreetInput",
    "SupplierCityInput",
    "SupplierStateInput",
    "SupplierZipInput",
    "SupplierEmailInput",
    "SupplierPhoneInput",
    "SupplierBusinessTypeBusinessInput",
    "SupplierBusinessTypeFarmInput",
    "SupplierLoadingOptionLoadingDockInput",
    "SupplierLoadingOptionForkliftInput",
    "SupplierLoadingOptionNoneInput",
  ];

  connect() {
    this.element[this.identifier] = this;

    this.initSupplierValues();

    this.element.addEventListener("change", (e) => {
      if (e.target.getAttribute("data-ltl-form-target") === "ShippingOption") {
        this.SelectedShippingOptionTarget.value = e.target.value;
      }
    });
  }

  initSupplierValues() {
    this.SupplierNameInputTarget.value = "Hybrid85";
    this.SupplierStreetInputTarget.value = "2005 N Somers Ave";
    this.SupplierCityInputTarget.value = "Fremont";
    this.SupplierStateInputTarget.value = "NE";
    this.SupplierZipInputTarget.value = "68025";
    this.SupplierEmailInputTarget.value = "corn@hybrid85.com";
    this.SupplierPhoneInputTarget.value = "4023824270";
  }

  handlePoSelect(po) {
    let existingPoIds = this.PurchaseOrderIdsInputTarget.value.split(",").filter((id) => id !== "");

    if (!existingPoIds.includes(po.id.toString())) {
      existingPoIds = existingPoIds.concat(po.id);
      this.PurchaseOrderIdsInputTarget.value = existingPoIds.join(",");

      const shippingOption = `
        <div class="rounded border-2 border-gray-300 p-4 mb-4 flex" id="shipping_option_po_id_${po.id}">
          <input type="radio" name="selected_shipping_option" id="shipping_option_${po.id}" value="${po.id}" data-ltl-form-target="ShippingOption" data-action="change->ltl-form#onPOSelectChange" required>
          <label for="shipping_option_${po.id}" class="ml-2">
            <div><strong>PO: </strong>${po.number}</div>
            <div><strong>Name: </strong>${po.customer_name}</div>
            <div><strong>Address: </strong>${po.order.shipping_address}, ${po.order.shipping_city}, ${po.order.shipping_state} ${po.order.shipping_zipcode}</div>
            <div><strong>Email: </strong>${po.order.email}</div>
            <div><strong>Phone: </strong>${po.order.phone_number}</div>
          </label>
          <button class="ml-2 text-red-500 text-sm" data-action="click->ltl-form#onPOCardRemove" data-purchase-order-id="${po.id}">Remove</button>
        </div>
      `;

      this.ShippingOptionsTarget.insertAdjacentHTML("beforeend", shippingOption);

      if (this.PurchaseOrderIdsInputTarget.value.split(",").length == 1) {
        this.ShippingOptionsTarget.querySelector(`#shipping_option_${po.id}`).checked = true;
        this.onPOSelectChange({ currentTarget: { value: po.id } });
      }
    }
  }

  onPOCardRemove(e) {
    const purchaseOrderId = e.currentTarget.dataset.purchaseOrderId;
    const poCard = this.ShippingOptionsTarget.querySelector(`#shipping_option_po_id_${purchaseOrderId}`)
    poCard.remove()

    const updatedPoIds = this.PurchaseOrderIdsInputTarget.value.split(",").filter((id) => id !== purchaseOrderId.toString());
    this.PurchaseOrderIdsInputTarget.value = updatedPoIds.join(",");
  }

  async onPOSelectChange(e) {
    const purchaseOrderId = e.currentTarget.value

    const response = await fetch(`/admin/purchase_orders/${purchaseOrderId}`, {
      headers: { Accept: "application/json" },
    });
    const data = await response.json();
    console.log('data', data)

    this.fillValuesFromPo(data)
  }

  handleSupplierSelect(supplier) {
    // Your existing code for handling the selected supplier and updating the form fields
    console.log("supplier: ", supplier);
    this.SupplierNameInputTarget.value = supplier.name;
    this.SupplierStreetInputTarget.value = supplier.address;
    this.SupplierCityInputTarget.value = supplier.city;
    this.SupplierStateInputTarget.value = supplier.state;
    this.SupplierZipInputTarget.value = supplier.zipcode;
    this.SupplierEmailInputTarget.value = "corn@hybrid85.com";
    this.SupplierPhoneInputTarget.value = "4023824270";
    if (supplier.business_type == "business") {
      this.SupplierBusinessTypeBusinessInputTarget.checked = true;
    } else {
      this.SupplierBusinessTypeFarmInputTarget.checked = true;
    }
    if (supplier.loading_option == "loading_dock") {
      this.SupplierLoadingOptionLoadingDockInputTarget.checked = true;
    } else if (supplier.loading_option == "forklift") {
      this.SupplierLoadingOptionForkliftInputTarget.checked = true;
    } else {
      this.SupplierLoadingOptionNoneInputTarget.checked = true;
    }
  }

  onSubmit(e) {
    const purchaseOrderIds = JSON.parse(this.PurchaseOrderIdsInputTarget.value);
    if (purchaseOrderIds.length > 1 && !this.SelectedShippingOptionTarget.value) {
      e.preventDefault();
      this.ShippingOptionValidationMessageTarget.classList.remove("hidden");
    } else {
      this.ShippingOptionValidationMessageTarget.classList.add("hidden");
    }
  }
}
